import { render } from "./NotificationPickCorrectAnswerEditPane.vue?vue&type=template&id=dd20980a&ts=true"
import script from "./NotificationPickCorrectAnswerEditPane.vue?vue&type=script&lang=ts"
export * from "./NotificationPickCorrectAnswerEditPane.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__